const TESTIMONIALS = [
  {
    quote:
      "Aaradhya started as a complete beginner. The batch is so small that every game she plays gets reviewed move by move — her confidence at the board has completely changed.",
    attribution: "Parent of Aaradhya Sharma",
    testId: "testimonial-card-1",
  },
  {
    quote:
      "Viaan waits for Tuesday and Thursday all week. The free trial told us exactly where he stood, and his focus at school has visibly improved since joining.",
    attribution: "Parent of Viaan",
    testId: "testimonial-card-2",
  },
  {
    quote:
      "We joined from Kondapur after seeing the academy's tournament photos. Jiyanshu played his first district event this year — medal or not, he came back hungrier.",
    attribution: "Parent of Jiyanshu",
    testId: "testimonial-card-3",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-20 border-b border-stone-300 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <div className="font-mono text-xs uppercase tracking-widest text-emerald-800 mb-2">Testimonials</div>
          <h2 className="font-display text-3xl uppercase tracking-tight text-emerald-950">Observed Growth</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((item) => (
            <div
              key={item.attribution}
              data-testid={item.testId}
              className="p-6 bg-[#faf9f5] rounded border border-stone-300 flex flex-col justify-between"
            >
              <p className="text-sm text-stone-700 leading-relaxed font-light">&ldquo;{item.quote}&rdquo;</p>
              <div className="mt-6 pt-4 border-t border-stone-200 font-mono text-xs text-stone-600">
                &middot;&nbsp;&nbsp;{item.attribution}
              </div>
            </div>
          ))}

          <div
            className="p-6 bg-[#faf9f5] border border-dashed border-stone-400 rounded flex flex-col justify-between text-stone-500"
            data-testid="testimonial-share-card"
          >
            <div>
              <div className="font-mono text-xs uppercase tracking-wider text-emerald-900 font-bold">Share Your Story</div>
              <p className="text-xs text-stone-600 mt-2">
                Have you competed in a recent tournament after training with our coaches? Send us your result.
              </p>
            </div>
            <div className="mt-6 pt-4 border-t border-stone-300">
              <a href="#contact" data-testid="testimonial-share-cta" className="font-mono text-xs text-emerald-950 font-bold hover:underline">
                Submit tournament update &rarr;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
